export const lowerTrim = (str: string): string => str.toLowerCase().trim()

export const capitalizeFirstLetter = (str: string): string => str.charAt(0).toUpperCase() + str.slice(1)

export const isString = (value: unknown): boolean => (typeof value === 'string') && (value !== '')

export const truncate = (str: string, maxLength: number, prefix = '...', truncatePosition: 'end' | 'center' = 'end'): string => {
  if (truncatePosition === 'center') {
    if (str.length <= maxLength) {
      return str
    } else {
      const startLength = Math.floor((maxLength - 3) / 2)
      const endLength = maxLength - startLength - 3
      return str.substring(0, startLength) + prefix + str.substring(str.length - endLength)
    }
  } else {
    return (str.length > maxLength)
      ? str.substring(0, maxLength - 3) + prefix
      : str
  }
}

export const validateSpecChars = (str: string): boolean => {
  const pattern = /[<>^*$%#@{}:;'"+=!~`/?,.]/g
  return !pattern.test(str)
}

export const validateZip = (value: string): boolean => {
  const validRegex = /^[/\d]{5}?$/
  return !!value.match(validRegex)
}

export const validateCanadaZip = (value: string): boolean => {
  const validRegex = /^[A-Za-z]\d[A-Za-z]\d[A-Za-z]\d$/
  return !!value.match(validRegex)
}

export const convertLinksToHTML = (text: string): string => {
  const urlPattern = /(https?:\/\/[^\s]+)/g
  return text.replace(urlPattern, '<a href="$1" target="_blank">$1</a>')
}

export const removeStrSpaces = (input: string): string => input.trim().replace(/\s+/g, '')

export const removeStrSpacesAfterComma = (input: string): string => input.replace(/,\s+/g, ',')
